const bestsellers = [
  {
    id: 1,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/Black-Beige-Stylish-Typography-Business-Tips-Pinterest-Pin-3-17553651615852025-08-16-17-26-01nROd1.png",
    name: "Taiwan Ocean Bomb 315ml Sparkling Water",
    description:
      "TAIWAN OCEAN BOMB 315ML Sparkling Water is an exotic flavored carbonated drink imported from Taiwan.",
    upc: "482736195024",
  },
  {
    id: 2,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/TAIWAN-OCEAN-BOMB-315ML-SPARKLING-WATER-MANGO-COCONUT17565084756712025-08-29-23-01-15xsSb0.jpg",
    name: "Mango Coconut Fanta 200ml Soda Can",
    description:
      "MANGO COCONUT FANTA 200ML Soda Can delivers a tropical fruit fusion in a refreshing soft drink.",
    upc: "739204861552",
  },
  {
    id: 3,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/FANTA-200ML-SODA-CAN17557298127302025-08-20-22-43-3267Ndh.jpg",
    name: "Orange (Soda)",
    description:
      "ORANGE Soda is a classic citrus-flavored soft drink with bold, refreshing taste.",
    upc: "615892347106",
  },
  {
    id: 4,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/lays-chips-40g-0217629022070282025-11-11-23-03-29i5y4f.jpg",
    name: "Taiwan Lays 59.4g Potato Chips Limited Edition",
    description:
      "TAIWAN LAYS 59.4G Potato Chips Limited Edition offers a savory salty crunch with unique regional flavor.",
    upc: "840193672458",
  },
  {
    id: 5,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/Black-Beige-Stylish-Typography-Business-Tips-Pinterest-Pin-21-17553767519362025-08-16-20-39-128hRm4.png",
    name: "Lays 104g Chips",
    description:
      "LAYS 104G Chips are classic potato chips with a satisfying, crispy texture.",
    upc: "392845710684",
  },
  {
    id: 6,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-29-at-11-57-03-AM-8-17628055579252025-11-10-20-12-29Y1pUi.jpeg",
    name: "Beef Potsticker Lays X Minions 90g Chips Special Edition",
    description:
      "BEEF Potsticker LAYS x Minions 90G Chips Special Edition combine a meaty potsticker flavor with fun themed packaging.",
    upc: "571608492317",
  },
  {
    id: 7,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/H24def08597344214b2044b5c6e02f039Q17628016838772025-11-10-19-07-55Z8fjc.jpg",
    name: "Banana Mirinda 330ml Soda",
    description:
      "BANANA MIRINDA 330ML Soda brings a fruity banana twist to a classic carbonated beverage.",
    upc: "964217503882",
  },
  {
    id: 8,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/MIRINDA-330ML-SODA-LYCHEE17641909935442025-11-26-21-03-13taUFR.jpg",
    name: "Lychee Mirinda 450ml Sparkling Water",
    description:
      "LYCHEE MIRINDA 450ML Sparkling Water offers a tropical lychee-infused refreshing drink.",
    upc: "308517946201",
  },
  {
    id: 9,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-29-at-11-57-03-AM-2-17628058075802025-11-10-20-16-38cYuut.jpeg",
    name: "Oreo 62g Thin Cookies",
    description:
      "OREO 62G Thin Cookies are a lighter, crisp version of the classic sandwich cookie.",
    upc: "756194832075",
  },
  {
    id: 10,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-29-at-11-57-03-AM-1-17628844662572025-11-11-18-07-46YMGEt.jpeg",
    name: "Oreo Double Combination Cookies 97g Limited Edition",
    description:
      "OREO Double Combination Cookies 97G Limited Edition feature two varieties of cookies in one pack.",
    upc: "519073826440",
  },
  {
    id: 11,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-28-at-12-41-25-PM-8-17628855478252025-11-11-18-25-48B7Fru.jpeg",
    name: "Original Tropicana 450ml Juice",
    description:
      "ORIGINAL TROPICANA 450ML Juice is a classic fruit juice beverage with natural flavor.",
    upc: "684291750936",
  },
  {
    id: 12,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/images17628868199112025-11-11-18-47-00nb8f6.jpg",
    name: "Korean Orion 60g Potato Chips",
    description:
      "KOREAN ORION 60G Potato Chips are savory snacks from South Korea with a distinct flavor profile.",
    upc: "247960381554",
  },
  {
    id: 13,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-29-at-11-57-02-AM-4-17628874812332025-11-11-18-58-02vFrVQ.jpeg",
    name: "Korea Doritos 84g Chips",
    description:
      "KOREA DORITOS 84G Chips offer the iconic Doritos taste with unique Asian flavoring.",
    upc: "890361742905",
  },
  {
    id: 14,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/MAXICORN17628880986362025-11-11-19-08-19Dn4yg.jpg",
    name: "Indonesian Doritos 140g",
    description:
      "INDONESIAN DORITOS 140G bring bold seasoning inspired by Indonesian tastes.",
    upc: "431850796214",
  },
  {
    id: 15,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/MAXICORN17628880986362025-11-11-19-08-19Dn4yg.jpg",
    name: "Maxicorn Orion Sun 70g Flakes",
    description:
      "MAXICORN ORION SUN 70G Flakes are crunchy corn snacks with savory seasoning.",
    upc: "705962184337",
  },
  {
    id: 16,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/CRISPY17628943045292025-11-11-20-51-44XEVzb.jpeg",
    name: "Lays 40g Crispy Fries",
    description:
      "LAYS 40G Crispy Fries are a lighter snack with crispy texture and classic flavor.",
    upc: "162940875633",
  },
  {
    id: 17,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/WhatsApp-Image-2025-10-28-at-12-41-25-PM17628841045362025-11-11-18-01-45EfUMk.jpeg",
    name: "Wrigleys Five 32g Chewing Gum 10ct",
    description:
      "WRIGLEYS FIVE 32G Chewing Gum 10CT offers long-lasting mint flavor in a multi-pack.",
    upc: "958204736119",
  },
  {
    id: 18,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/TAIWAN-DORITOS-40G-POTATO-CHIPS17571815912322025-09-06-17-59-54796QH.png",
    name: "Taiwan Doritos 40g Potato Chips",
    description:
      "TAIWAN DORITOS 40G Potato Chips deliver bold flavor in a compact pack.",
    upc: "604873912580",
  },
  {
    id: 19,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/Black-Beige-Stylish-Typography-Business-Tips-Pinterest-Pin17546837471332025-08-08-20-09-09GUvdL.png",
    name: "Oreo Cookies 388g Gift Box 12ct",
    description:
      "OREO Cookies 388G Gift Box 12CT is a large assortment pack ideal for gifting or sharing.",
    upc: "813579460228",
  },
  {
    id: 20,
    image:
      "https://d1pd8tx4g8m009.cloudfront.net/product-images/Black-Beige-Stylish-Typography-Business-Tips-Pinterest-Pin-2-17553645377572025-08-16-17-15-37yg6nT.png",
    name: "Oreo 120g Mini Cookies 6ct",
    description:
      "OREO 120G Mini Cookies 6CT are bite-size classic cookies perfect for snacking.",
    upc: "349681257904",
  },
];

export default bestsellers;
